{
  "Authentication_LoginButton": "Se connecter",
  "LoginForm_LoginTitle": "Connectez-vous à votre compte",
  "LoginForm_WelcomeBack": "Bienvenue ! Veuillez saisir vos coordonnées.",
  "LoginForm_Email": "Nom d'utilisateur",
  "LoginForm_EmailRequired": "L'email est obligatoire",
  "LoginForm_InvalidEmail": "Le nom d'utilisateur doit être une adresse e-mail",
  "LoginForm_EmailPlaceholder": "Entrez votre email",
  "LoginForm_Password": "Mot de passe",
  "LoginForm_PasswordRequired": "Le mot de passe est requis",
  "LoginForm_PasswordPlaceholder": "••••••••",
  "LoginForm_RememberMe": "Souviens-toi de moi",
  "LoginForm_ForgotPassword": "Mot de passe oublié",
  "LoginForm_SignIn": "Se connecter",
  "NAME": "Authentication",
  "LoginForm_Username": "Nom d'utilisateur",
  "LoginForm_UsernameRequired": "Le nom d'utilisateur est requis",
  "LoginForm_UsernamePlaceholder": "Entrez votre nom d'utilisateur",
  "LoginForm_CME": "FMC",
  "LoginForm_Or": "(Ou)",
  "LoginForm_Server": "Serveur",
  "LoginForm_ServerPlaceholder": "Veuillez sélectionner le serveur auquel vous connecter",
  "LoginForm_LoginLanding_UserOnMultipleServices": "Ce nom d'utilisateur existe sur plusieurs services. Veuillez fournir des informations supplémentaires pour l'identifier.",
  "LoginForm_LoginLanding_UserNonAdmin_Error": "Un problème de connexion à votre compte est survenu. Veuillez contacter votre administrateur pour résoudre le problème.",
  "LoginForm_LandingPage_NextButton": "Continuer",
  "Authentication_ChangeBrowserProfile": "Modifier le profil du navigateur",
  "LoginForm_LoginLanding_User_Not_Found_Error": "Nous n'avons pas trouvé le nom d'utilisateur que vous avez saisi. Veuillez vérifier et réessayer."
}